import React from 'react';
import { Accordion, AccordionItem as Item } from '@szhsin/react-accordion';
import { pdfFiles, PDFAnchor } from '../body/Pdf';
import AddHome from '../../../../../assets/handouts/addToHome_ezParent.pdf';

const AccordionItem = ({ header, ...rest }) => (
  <Item
    {...rest}
    header={({ state: { isEnter } }) => (
      <>
        {header}
        <img
          className={`ml-auto transition-transform duration-200 ease-out ${
            isEnter && 'rotate-180'
          }`}
          src={'/ChevronDown.svg'}
          alt='Chevron'
        />
      </>
    )}
    className='border-b-2 border-slate-600 max-w-2xl m-auto  overflow-hidden  '
    buttonProps={{
      className: ({ isEnter }) =>
        ` flex w-full p-4 text-left hover:bg-gray-400 hover:text-white text-lg ${
          isEnter ? 'bg-light-blue text-white ' : ' bg-gray-300 '
        }`,
    }}
    contentProps={{
      className: 'transition-height duration-200 ease-out  ',
    }}
    panelProps={{ className: 'p-4' }}
  />
);

const ResourceLibrary = () => {
  return (
    <div className='p-8'>
      <div className=' border-2 border-slate-600 border-b-0  max-w-2xl m-auto rounded overflow-hidden shadow-lg '>
        <div className=' border-b-2 border-slate-600 text-3xl bg-purple relative text-white p-4 text-center font-bold flex items-center'>
          <div className='flex justify-center items-center gap-2 text-lg bg-white rounded-full p-2 overflow-hidden'>
            <img
              className='w-8 h-8'
              src='/pdfIcon.png'
              alt='Resource Library Icon'
            />
          </div>
          <h2 className='absolute left-0 right-0 m-auto'>
            <i>ez</i>Training Resources
          </h2>
        </div>
        <Accordion transition transitionTimeout={200}>
          <AccordionItem header='Introduction' initialEntered>
            <ul className='flex flex-col gap-4 items-start text-left'>
              {pdfFiles.introduction.map((pdf, index) => (
                <li key={index}>
                  <PDFAnchor href={pdf.url}>{pdf.name}</PDFAnchor>
                </li>
              ))}
            </ul>
          </AccordionItem>
          <AccordionItem header='Program Strategies Part 1'>
            <ul className='flex flex-col gap-4 items-start text-left'>
              {pdfFiles.strategiesPart1.map((pdf, index) => (
                <li key={index}>
                  <PDFAnchor href={pdf.url}>{pdf.name}</PDFAnchor>
                </li>
              ))}
            </ul>
          </AccordionItem>
          <AccordionItem header='Program Strategies Part 2'>
            <ul className='flex flex-col gap-4 items-start text-left'>
              {pdfFiles.strategiesPart2.map((pdf, index) => (
                <li key={index}>
                  <PDFAnchor href={pdf.url}>{pdf.name}</PDFAnchor>
                </li>
              ))}
            </ul>
          </AccordionItem>
          <AccordionItem header='Hybrid ezParent Group Resources'>
            <ul className='flex flex-col gap-4 items-start text-left'>
              <li>
                <a
                  href='/resource-library/HYBRID-DELIVERY-GROUP-SESSION-SLIDES.pptx'
                  download='HYBRID-DELIVERY-GROUP-SESSION-SLIDES.pptx'
                  style={{
                    textDecoration: 'underline',
                  }}
                  className='text-blue-600 transition-colors duration-200 text-lg cursor-pointer hover:text-blue-700'
                >
                  Hybrid Delivery Group Session Slides - PowerPoint
                </a>
              </li>
              <li>
                <a
                  href='https://docs.google.com/presentation/d/1xIOEWv4o5nAaE_G8nQd9Mo8_yuv7PvhT/edit?slide=id.p1#slide=id.p1'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    textDecoration: 'underline',
                  }}
                  className='text-blue-600 transition-colors duration-200 text-lg cursor-pointer hover:text-blue-700'
                >
                  Hybrid Delivery Group Session Slides - Google Slides
                </a>
              </li>
              {pdfFiles.hybridDelivery.map((pdf, index) => (
                <li key={index}>
                  <PDFAnchor href={pdf.url}>{pdf.name}</PDFAnchor>
                </li>
              ))}
              <li>
                <PDFAnchor href='/resource-library/Fillable-ezParent-Schedule.pdf'>
                  Fillable <i>ez</i>Parent Schedule without Celebration Session
                </PDFAnchor>
              </li>
              <li>
                <PDFAnchor href='/resource-library/Fillable-ezParent-Schedule-Celebration.pdf'>
                  Fillable <i>ez</i>Parent Schedule with Celebration Session
                </PDFAnchor>
              </li>
              <li>
                <PDFAnchor href='/resource-library/EZCertificate.pdf'>
                  Fillable <i>ez</i>Parent Completion Certificates
                </PDFAnchor>
              </li>
            </ul>
          </AccordionItem>
          <AccordionItem header='Helpful Links'>
            <ul className='flex flex-col gap-4 items-start text-left'>
              <li>
                <PDFAnchor href={AddHome}>Add to Homescreen</PDFAnchor>
              </li>
              <li>
                <PDFAnchor href='https://www.chicagoparentprogram.org/research'>
                  Chicago Parent Program Research
                </PDFAnchor>
              </li>
              <li>
                <PDFAnchor href='/facilitator/welcome-video'>
                  Welcome to <i>ez</i>Training Video
                </PDFAnchor>
              </li>
              <li>
                <PDFAnchor href='/facilitator/ezparent-intro-video'>
                  <i>ez</i>Parent Intro Video
                </PDFAnchor>
              </li>
            </ul>
          </AccordionItem>
        </Accordion>
      </div>
      <div className='max-w-2xl m-auto px-0 py-6 text-left'>
        <a
          href='/resource-library/Hybrid-Group-Facilitation-Manual.pdf'
          target='_blank'
          rel='noopener noreferrer'
          className='inline-flex items-center justify-center rounded bg-light-blue px-6 py-3 text-lg font-bold text-white no-underline transition-colors duration-200 hover:bg-blue-600'
        >
          ezParent Hybrid Group Facilitation Manual
        </a>
      </div>
    </div>
  );
};

export default ResourceLibrary;
